// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__yK0K2","footer_bg":"footer_footer_bg__JA-do","wave":"footer_wave__qIInP"};